// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2hDSo","errorLogs":"EditorFooter_errorLogs__8cjO5"};